<template>
    <div class="multiple-menu-item-container">
        <div class="multiple-menu-item" v-for="child in menuItem.ChildItems" :key="child.MenuItemId">
            <menu-item-image :item="child" size="small" />
            <div class="multiple-menu-item-summary">
                <div class="multiple-menu-item-info">
                    <h4 class="multiple-menu-item-name">{{ child.DisplayName }}</h4>
                    <serving-size :item="child" />
                    <button class="multiple-menu-item-link" @click="onMore">Full Nutrition Details</button>
                </div>
                <div class="multiple-menu-item-details">
                    <allergens :item="child" variant="extra-large" />
                    <nutrition-components :item="child" :limit="4" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import allergens from '../../../components/allergens.vue';
import menuItemMixin from '../../../js/mixins/menuItemMixin';
import menuItemImage from './menuItemImage.vue';
import nutritionComponents from './nutritionComponents.vue';
import servingSize from './servingSize.vue';

export default {
    name: 'multiple-menu-item',
    components: {
        'menu-item-image': menuItemImage,
        'nutrition-components': nutritionComponents,
        'allergens': allergens,
        'serving-size': servingSize
    },
    mixins: [menuItemMixin],
    props: {
        menuItem: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.multiple-menu-item-container {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.multiple-menu-item {
    display: flex;
    gap: 16px;
    padding: 16px 0;
    
    border-bottom: 1px solid #E0E0E0;
}

.multiple-menu-item:last-child {
    border-bottom: none;
}

.multiple-menu-item-summary {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    
    gap: 8px;
}

.multiple-menu-item-info {
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
    height: 100%;
}

.multiple-menu-item-name {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}

.multiple-menu-item-link {
    font-size: 12px;
    color: #6B8B2C;
    text-decoration: none;
    cursor: pointer;
}

.multiple-menu-item-link:hover {
    text-decoration: underline;
}

.multiple-menu-item-details {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-end;
    justify-content: space-between;
    flex: 3;
}

@media (max-width: 767px) {
    .multiple-menu-item {
        flex-wrap: wrap;
    }
    
    .multiple-menu-item-details {
        width: 100%;
        justify-content: space-between;
    }
}
</style>